<template>
  <BoardersTable></BoardersTable>
</template>

<script>
import BoardersTable from '../../components/BoardersTable'
export default {
  name: 'test',
  components: { BoardersTable }
}
</script>

<style scoped>

</style>
